import styled from 'styled-components';
import { CloseIcon, IconSize } from '@ardoq/icons';
import { space } from '@ardoq/design-tokens';

export const CloseFilterPillIcon = styled(CloseIcon).attrs({
  iconSize: IconSize.SMALL,
})`
  padding-right: ${space.xxsmall};
`;
